import './style.css';

import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import IIIF from 'ol/source/IIIF';
import IIIFInfo from 'ol/format/IIIFInfo';

import '@fortawesome/fontawesome-free/css/all.css';

import { Client, query } from 'faunadb';

var storyline;

var state = {
	initialized: false,
	currentStep: null,
	currentSource: null,
	currentSourceMaxExtent: null
};

var initialHash = window.location.hash.substring(1).split('/');

if (!initialHash[0] || initialHash[0].length < 1) {
	failInitialize();
}

var client = new Client({ secret: 'fnADp5sdjjACE35-7BlTJTtVk3cXfifrqUVrh0xu' });

client
	.query(
		query.Map(
			query.Paginate(query.Match(query.Index('map-stories-by-id'), initialHash[0])),
			query.Lambda('X', query.Get(query.Var('X')))
		)
	)
	.then((d) => {
		initialize(d.data[0].data);
	})
	.catch((e)=>{console.log(e);});

var layer = new TileLayer(),
	map = new Map({
		layers: [ layer ],
		target: 'viewer',
		controls: []
	});

function loadNewSource(iiifEndpoint, extent) {
	fetch(iiifEndpoint)
		.then(function(response) {
			response
				.json()
				.then(function(imageInfo) {
					var options = new IIIFInfo(imageInfo).getTileSourceOptions();
					if (options === undefined || options.version === undefined) {
						return;
					}
					options.zDirection = -1;
					var iiifTileSource = new IIIF(options);
					layer.setSource(iiifTileSource);
					state.currentSourceMaxExtent = iiifTileSource.getTileGrid().getExtent();
					map.setView(
						new View({
							resolutions: iiifTileSource.getTileGrid().getResolutions(),
							extent: state.currentSourceMaxExtent,
							constrainOnlyCenter: true
						})
					);
					if (extent === 'fit') {
						map.getView().fit(iiifTileSource.getTileGrid().getExtent(), { padding: [ 0, 0, 150, 0 ] });
					} else {
						map.getView().fit(JSON.parse(extent), { padding: [ 0, 0, 150, 0 ] });
					}
				})
				.catch(function() {});
		})
		.catch(function() {});
}

function toggleFullscreen() {
	var d = document.documentElement;

	if (!fullscreenFlag) {
		if (d.requestFullscreen) {
			d.requestFullscreen();
		} else if (d.mozRequestFullScreen) {
			/* Firefox */
			d.mozRequestFullScreen();
		} else if (d.webkitRequestFullscreen) {
			/* Chrome, Safari and Opera */
			d.webkitRequestFullscreen();
		} else if (d.msRequestFullscreen) {
			/* IE/Edge */
			d.msRequestFullscreen();
		}
		fullscreenFlag = true;
		document.getElementById('fullscreen-icon').classList.remove('fa-expand');
		document.getElementById('fullscreen-icon').classList.add('fa-compress-arrows-alt');
	} else {
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.mozCancelFullScreen) {
			/* Firefox */
			document.mozCancelFullScreen();
		} else if (document.webkitExitFullscreen) {
			/* Chrome, Safari and Opera */
			document.webkitExitFullscreen();
		} else if (document.msExitFullscreen) {
			/* IE/Edge */
			document.msExitFullscreen();
		}
		fullscreenFlag = false;
		document.getElementById('fullscreen-icon').classList.add('fa-expand');
		document.getElementById('fullscreen-icon').classList.remove('fa-compress-arrows-alt');
	}
}

function goToStep(n) {
	if (n === storyline.stops.length + 1) {
		n = 0;
	}

	if (n < 0 || n > storyline.stops.length + 1) {
		return;
	} else {
		updateNavButtons(n);

		if (n === storyline.stops.length) {
			layer.setOpacity(0.2);
			document.getElementById('caption-guts').style.display = 'none';
			document.getElementById('caption-colophon').style.display = 'block';
			state.currentStep = n;
		} else {
			
			layer.setOpacity(1);
			document.getElementById('caption-colophon').style.display = 'none';
			document.getElementById('caption-guts').style.display = 'block';

			var thisStep = storyline.stops[n];

			// Check if the step we're moving to has the same source as the previous step
			// If it doesn't we need to load a new source
			if (
				!state.initialized ||
				state.currentStep === storyline.stops.length ||
				thisStep.sourceId != storyline.stops[state.currentStep].sourceId
			) {
				var explodedSource = thisStep.sourceId.split('#');
				var commId = explodedSource[0];
				var seq = parseInt(explodedSource[1]);
				fetch(`https://www.digitalcommonwealth.org/search/${commId}/manifest`)
					.then(function(response) {
						response
							.json()
							.then(function(manifest) {
								var imageSource = manifest.sequences[0].canvases[seq].images[0].resource.service['@id'];
								loadNewSource(imageSource, thisStep.extent);
							})
							.catch(failInitialize);
					})
					.catch(failInitialize);
			} else {
				// Otherwise, just set the zoom and center of this step

				if (thisStep.extent === 'fit') {
					map.getView().fit(state.currentSourceMaxExtent, { duration: 1500, padding: [ 0, 0, 150, 0 ] });
				} else {
					map.getView().fit(JSON.parse(thisStep.extent), { duration: 1500, padding: [ 0, 0, 150, 0 ] });
				}
			}
			document.getElementById('caption-title').innerHTML = thisStep.captionHeader;
			document.getElementById('caption-text').innerHTML = thisStep.captionText;
			document.getElementById('slide-counter').innerText = `${n + 1}/${storyline.stops.length}`;

			state.currentStep = n;
			history.pushState({ step: n }, null, `${window.location.hash.split('/')[0]}/${n + 1}`);
		}
	}
}

function updateNavButtons(n) {
	if (n == 0) {
		document.getElementById('back-button').classList.add('caption-back-forward-button--disabled');
		document.getElementById('back-arrow').classList.remove('fa-arrow-left');
		document.getElementById('back-arrow').classList.add('fa-stop-circle');
		document.getElementById('forward-arrow').classList.add('fa-arrow-right');
		document.getElementById('forward-arrow').classList.remove('fa-redo');
	} else if (n == storyline.stops.length) {
		document.getElementById('forward-arrow').classList.remove('fa-arrow-right');
		document.getElementById('forward-arrow').classList.add('fa-redo');
	} else {
		document.getElementById('back-button').classList.remove('caption-back-forward-button--disabled');
		document.getElementById('back-arrow').classList.add('fa-arrow-left');
		document.getElementById('back-arrow').classList.remove('fa-stop-circle');
		document.getElementById('forward-arrow').classList.add('fa-arrow-right');
		document.getElementById('forward-arrow').classList.remove('fa-redo');
	}
}

function failInitialize() {
	console.log('Failed initialization');
	document.getElementById('frames-all').innerHTML =
		'<h1 class="error">Sorry, you seem to have followed an invalid link</h1>';
}

function initialize(d) {
	storyline = d;
	goToStep(0);

	// Listens for back button
	window.addEventListener('popstate', function(e) {
		goToStep(e.state.step);
	});

	document.onkeydown = function(e) {
		if (e.keyCode === 37) {
			goToStep(state.currentStep - 1);
		}
		if (e.keyCode === 39) {
			goToStep(state.currentStep + 1);
		}
	};

	// Interaction listeners
	document.getElementById('forward-button').addEventListener('click', function() {
		goToStep(state.currentStep + 1);
	});
	document.getElementById('back-button').addEventListener('click', function() {
		goToStep(state.currentStep - 1);
	});

	document.getElementById('collections-page').addEventListener('click', function() {
		if (storyline.stops[state.currentStep].repo == 'lmec') {
			window.open(`https://collections.leventhalmap.org/search/${storyline.stops[state.currentStep].sourceId}`);
		} else {
			window.open(`https://www.digitalcommonwealth.org/search/${storyline.stops[state.currentStep].sourceId}`);
		}
	});

	// document.getElementById('fullscreen-toggle').addEventListener('click', toggleFullscreen);
	document.title = `${storyline.metadata.title} · Leventhal Map & Education Center`;
	document.getElementById('colophon-title').innerText = storyline.metadata.title;
	document.getElementById('colophon-author').innerText = storyline.metadata.author;
	document.getElementById('colophon-date').innerText = storyline.metadata.published;
	document.getElementById('colophon-link').innerText =
		location.protocol + '//' + location.hostname + location.pathname + '#' + initialHash[0];
	state.initialized = true;
}
